/**
 * Guards a list of plain-text strings against rich-text (Syncfusion editor) HTML.
 *
 * Diagnostic best practices are short plain sentences, but the backend falls back to the
 * diagnostic's rich-text comment when the diagnostic has no structured best practices. That
 * comment is a message to the plant — editor HTML with inline base64 images — and no amount of
 * tag stripping turns it into a best practice, so it is dropped rather than rendered. Tracked
 * backend-side in PLAT-4345.
 */

/** True when the string carries markup. Plain best-practice sentences never do. */
export const looksLikeHtml = (value: string): boolean => /<\/?[a-z][^>]*>/i.test(value);

/** The items that are actual plain-text sentences; rich-text ones and blanks are dropped. */
export const plainTextItems = (values: readonly string[]): string[] =>
    values
        .filter((value) => !looksLikeHtml(value))
        .map((value) => value.trim())
        .filter(Boolean);
